import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Install BootstrapVue
Vue.use(BootstrapVue, {
  BFormDatepicker: {
    labelPrevDecade: "Década Anterior",
    labelPrevYear: "Ano Anterior",
    labelPrevMonth: "Mês Anterior",
    labelCurrentMonth: "Mês Atual",
    labelNextMonth: "Próximo Mês",
    labelNextYear: "Próximo Ano",
    labelNextDecade: "Próxima Década",
    labelToday: "Hoje",
    labelSelected: "Data Selecionada",
    labelNoDateSelected: "Nenhuma Data Selecionada",
    labelCalendar: "Calendário",
    labelNav: "Navegação do Calendário",
    labelHelp: "Use as teclas de seta para navegar no calendário",
    dateFormatOptions: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
});
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
